import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalComponent } from './modal.component';
import { TestModalChildComponent } from './test-modal-child.component';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';

@NgModule({
    imports: [
        CommonModule,
        FontIconModule,
    ],
    declarations: [
        ModalComponent,
        TestModalChildComponent,
    ],
    providers: [],
    exports: [
        ModalComponent,
    ]
})
export class ModalModule {
    static entry = ModalComponent;
}
